import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const verificationService = {
    getStatus: async () => {
        try {
            const res = await axiosService.get(endPoints.verification.status);

            return res;
        } catch (error) {
            throw error;
        }
    },
    submit: async (data) => {
        try {
            const res = await axiosService.post(endPoints.verification.submit, data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    // Partial resubmission: re-upload a single document ({type, file}). The
    // backend supersedes the prior same-type doc and, once no rejected docs
    // remain, returns the attempt to "under review" automatically.
    uploadDocument: async (data) => {
        try {
            const res = await axiosService.post(endPoints.verification.documents, data, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    // Phone OTP: request a code, then verify it.
    sendPhoneOtp: async (phone) => {
        try {
            return await axiosService.post(endPoints.verification.sendOtp, { phone });
        } catch (error) {
            throw error;
        }
    },
    verifyPhoneOtp: async (phone, code) => {
        try {
            return await axiosService.post(endPoints.verification.verifyOtp, { phone, code });
        } catch (error) {
            throw error;
        }
    },
}

export {
    verificationService,
}
